import { useCallback } from 'react';
import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd';
import { useDispatch } from '@s20/hooks/redux.hooks';
import { setUserShortcuts } from '@s20/slices/features/common.slice';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../Common';
import { FlattenedSections } from './constants';

export const QuickLinks = ({
    shortcuts,
    renderPage,
    editing,
}) => {
    const dispatch = useDispatch();

    const handleDragEnd = useCallback((result) => {
        const { source, destination } = result;

        let newShortcuts = [...shortcuts];
        const from = source.index;
        const to = destination.index;

        const item = newShortcuts[from];
        newShortcuts.splice(from, 1);
        newShortcuts.splice(to, 0, item);

        newShortcuts = newShortcuts.map((shortcut, order) => ({
            ...shortcut,
            order,
        }));

        dispatch(setUserShortcuts(newShortcuts));

        void httpClient.post(
            `${ApiRoutes.shortcut.updateAll()}`,
            newShortcuts,
        );
    }, [dispatch, shortcuts]);

    const handleRemoveShortcut = useCallback((shortcutId) => {
        const newShortcuts = shortcuts.map((shortcut) => {
            if (shortcut.id === shortcutId) {
                return {
                    ...shortcut,
                    active: false,
                };
            }

            return shortcut;
        });

        dispatch(setUserShortcuts(newShortcuts));

        void httpClient.post(
            `${ApiRoutes.shortcut.updateAll()}`,
            newShortcuts,
        );
    }, [dispatch, shortcuts]);

    if (editing) {
        return (
            <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="quick-links">
                    {(droppableProvided) => (
                        <div
                            id="quick-links"
                            className="quick-links"
                            {...droppableProvided.droppableProps}
                            ref={droppableProvided.innerRef}
                        >
                            {shortcuts.map((shortcut, i) => {
                                const page = FlattenedSections.find((item) => item.name === shortcut.name);

                                if (!page) {
                                    return null;
                                }

                                return (
                                    <Draggable
                                        index={i}
                                        key={shortcut.id}
                                        draggableId={shortcut.id}
                                    >
                                        {(draggableProvided) => (
                                            <div
                                                ref={draggableProvided.innerRef}
                                                {...draggableProvided.draggableProps}
                                            >
                                                {renderPage(page, editing, {
                                                    provided: draggableProvided,
                                                    handleRemoveShortcut: () => handleRemoveShortcut(shortcut.id),
                                                })}
                                            </div>
                                        )}
                                    </Draggable>
                                );
                            })}

                            {droppableProvided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        );
    }

    return (
        <div
            id="quick-links"
            className="quick-links"
        >
            {shortcuts.map((shortcut) => {
                const page = FlattenedSections.find((item) => item.name === shortcut.name);

                return renderPage(page, editing);
            })}
        </div>
    );
};